import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { TutorialCard, TutorialPlayer, useTutorials } from '../../tutorials/Tutorials.jsx';

// Public "Aide / Help" page: tutorial videos (Admin > Contenu du site > Aide).
export default function Help() {
  const { t } = useI18n();
  const list = useTutorials('help');
  const [open, setOpen] = useState(null);
  useEffect(() => { document.title = `${t('help.title')} — PME Trade Canada`; }, [t]);
  // ?play=<id>: open that video (link in an email, e.g. the product invitation).
  const [params] = useSearchParams();
  const play = Number(params.get('play')) || 0;
  useEffect(() => {
    if (!play) return undefined;
    let alive = true;
    api(`/tutorials/one/${play}`).then((tut) => { if (alive) setOpen(tut); }).catch(() => {});
    return () => { alive = false; };
  }, [play]);
  return (
    <div className="container page help-page">
      <h1>{t('help.title')}</h1>
      <p className="muted lead">{t('help.lead')}</p>
      {list === null ? <p className="muted">{t('common.loading')}</p> : list.length === 0 ? (
        <p className="muted">{t('help.empty')} <Link to="/contact">{t('nav.contact')}</Link></p>
      ) : (
        <ul className="tut-grid">{list.map((x) => <TutorialCard key={x.id} tut={x} onOpen={setOpen} />)}</ul>
      )}
      <p className="muted small help-more">{t('help.more')} <Link to="/contact">{t('nav.contact')}</Link></p>
      {open && <TutorialPlayer tut={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
